import React from "react";

import { useGetFullApplicantion } from "manager/hooks/api";

import { findLumenResult } from "shared/components/vega/LumenV2";
import { Timestamp } from "shared/components/vega/Timestamp";
import { useGetApplicantFromApplicationService } from "shared/hooks/api";

import { CategoryId } from "../constants";

import ApplicantGroupCard from "./components/ApplicantGroupCard";
import ApplicantInfoCardWithActions from "./components/ApplicantInfoCard";
import { isLumenDataAvailable } from "./helpers/applicantHistoryHelpers";
import { getCardDetailsByCategory } from "./helpers/applicantStatusHelpers";

import "./styles.css";

const ApplicantSummary = ({
  id,
  lumenRun,
  legacyApp,
  isLumenStillCalculating,
  refetchDeal,
}) => {
  const { applicant } = useGetApplicantFromApplicationService(id);
  const applicantLumenResult = findLumenResult(lumenRun, applicant?.id);
  const applicationLumenResult = findLumenResult(lumenRun);
  const {
    fullApplication: application,
    isFullApplicationLoading,
    isFullApplicationFetching,
  } = useGetFullApplicantion(legacyApp?.appId);

  if (isFullApplicationLoading || isFullApplicationFetching || !application) {
    return null;
  }

  const isLumenAvailable = isLumenDataAvailable(
    applicantLumenResult,
    isLumenStillCalculating
  );

  const isSubmitted = legacyApp?.info?.isSubmitted;
  const showBackgroundCreditSection =
    applicant?.shouldRunBackgroundAndCreditChecks;

  // Use the helper function to generate all card details
  const cardDetailsByCategory = getCardDetailsByCategory(
    lumenRun,
    legacyApp,
    application,
    applicantLumenResult,
    applicationLumenResult,
    isLumenAvailable,
    isSubmitted,
    showBackgroundCreditSection
  );

  return (
    <div className="app-summary-v2 vega container content">
      <div className="applicant-cards-grid">
        <ApplicantInfoCardWithActions
          id={id}
          applicant={applicant}
          legacyApp={legacyApp}
          refetchDeal={refetchDeal}
        />
        {Object.entries(cardDetailsByCategory).map(([categoryId, details]) => {
          // Convert string to CategoryId enum value
          const category = categoryId as CategoryId;

          // Skip background check sections if not showing
          if (
            [
              CategoryId.CREDIT_HISTORY,
              CategoryId.RENTAL_HISTORY,
              CategoryId.CRIMINAL_HISTORY,
            ].includes(category) &&
            !showBackgroundCreditSection
          ) {
            return null;
          }

          return (
            <div key={categoryId} className="applicant-card-container">
              <ApplicantGroupCard {...details} />
            </div>
          );
        })}
      </div>

      {applicant?.updatedAt && <Timestamp timestamp={applicant?.updatedAt} />}
    </div>
  );
};

export default ApplicantSummary;
